import { default as TeamPage } from "../components/Team";

const Team = () => {
  return <TeamPage />;
};

export default Team;
